import { Stack, Image } from "@mantine/core";
import { Outlet } from "react-router-dom";

import { getAssetUrl } from "@utils/getAssetUrl";

/** 有 logo 外框的版面（start / text-setting 用；home 不套這層）。 */
export default function WallPaperLayoutPage() {
  return (
    <Stack
      h="100svh"
      w="100%"
      gap={0}
      bg="#FFFCF6"
      style={{ overflowX: "hidden", overflowY: "auto" }}
    >
      <Image
        src={getAssetUrl("/images/campaign-wallpaper/logo.svg")}
        alt="Tory Burch"
        w="48.8vw"
        py="7.1vw"
        mx="auto"
        style={{ flexShrink: 0 }}
      />
      <Outlet />
    </Stack>
  );
}
